import { render, staticRenderFns } from "./procesar.pedido.vue?vue&type=template&id=011008a3&scoped=true"
import script from "./procesar.pedido.vue?vue&type=script&lang=js"
export * from "./procesar.pedido.vue?vue&type=script&lang=js"
import style0 from "./procesar.pedido.vue?vue&type=style&index=0&id=011008a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011008a3",
  null
  
)

export default component.exports